module.exports = __webpack_public_path__ + "img/icon-fullscreen-close.6c8cc0e3.svg";